import { Injectable, Inject } from '@angular/core';
import { Observable, Subject, filter, interval, of, single, takeUntil, takeWhile, timeInterval, endWith } from 'rxjs';
import { AsyncService } from './async.service';
import { AuthService } from './auth.service';

@Injectable()
export class SupportcService {

	//	cancelationToken: Subject<void>;
	constructor(private asyncSrv: AsyncService, private auth: AuthService) { }
	//supportComponent: HTMLElement;

	Init = () => {
		let win = window as any;
		win.Tawk_API = win.Tawk_API || {};
		win.Tawk_LoadStart = new Date();

		var s1 = document.createElement("script");
		let s0 = document.getElementsByTagName("script")[0];
		s1.async = true;
		s1.src = 'https://embed.tawk.to/64f848d2a91e863a5c11f238/1h9ktotma';
		s1.charset = 'UTF-8';
		s1.setAttribute('crossorigin', '*');
		s0.parentNode.insertBefore(s1, s0);

		//this.fixServiceButton();
	}

	//private fixServiceButton = () => {

	//	this.cancelationToken = this.asyncSrv.createCancelationToken();
	//	this.asyncSrv.waitUntil(100,
	//		() => document.getElementsByClassName('widget-visible')[0]?.getElementsByTagName('iframe')?.length > 0,
	//		() => {
	//			let frame = document.getElementsByClassName('widget-visible')[0]?.getElementsByTagName('iframe')[0];
	//			//frame.style.left = "6px";
	//			this.supportComponent = frame.contentDocument.getElementsByClassName('tawk-button')[0] as HTMLElement;


	//			//    this.supportComponent.style.display = 'none';
	//		}, this.cancelationToken);
	//}

	click = () => {
		//this.supportComponent.click();
	}
	sendMessage = () => {
		let win = window as any;
		//let directOpen = true;
		//if (this.auth.getUserData()?.authOut != null) {
		//	if (!win.Tawk_API.visitor?.name) {
		//		directOpen = false;
		//		win.Tawk_API.setAttributes({
		//			'name': this.auth.getUserData().authOut.un
		//		}, (err: string) => {
		//			win.Tawk_API.toggle();
		//		});
		//	}
		//}
		//if (directOpen)
		win.Tawk_API.toggle();
		//this.supportComponent?.click();
	}
	Dispose = () => {
		//this.asyncSrv.dispose(this.cancelationToken);
	}
}
